// Categories that group nav items in the sidebar.
// Order here determines render order in SidebarNav.
// `defaultCollapsed` controls initial state for users with no saved preference.

export const NAV_CATEGORIES = [
  { key: 'workspace',   label: 'Arbetsyta',          defaultCollapsed: false },
  { key: 'projects',    label: 'Projekt',            defaultCollapsed: false },
  { key: 'management',  label: 'Ledningssystem',     defaultCollapsed: false },
  { key: 'finance',     label: 'Affär & Ekonomi',    defaultCollapsed: false },
  { key: 'tools',       label: 'Verktyg & Personal', defaultCollapsed: false },
  { key: 'stod',        label: 'Stöd',               defaultCollapsed: false },
  { key: 'admin',       label: 'Administration',     defaultCollapsed: true  },
];

export const NAV_CATEGORY_BY_KEY = Object.fromEntries(
  NAV_CATEGORIES.map((c) => [c.key, c]),
);
